import Vue from 'vue';
import VueRouter from 'vue-router';

import Page from './pages/page/routes';
import Case from './pages/cases/routes';

Vue.use(VueRouter);

const routes = [
    Case,
    Page, // wildcard, must come last
];


let router = new VueRouter({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes: routes,
});

export default router;